import { ConversationNode } from "@/commands/AIConcierge/types";

// サンプルデータ
export const sampleConversationData: ConversationNode = {
  characterComment: "聞きたいことを\n選んでください",
  choices: [
    "おすすめの講演を知りたい",
    "Sansan、Bill One、Contract Oneに関する質問・相談をしたい",
    "Voyagers（ユーザー）のイチ押し機能を知りたい",
    "デジタルスタンプラリーのスタンプを集められる場所が知りたい",
  ],
  characterGifPattern: "default",
  characterCommentImagePattern: "kaku",
  children: [
    {
      characterComment: "どちらの講演を\n聞きたいですか？",
      choices: [
        "Voyagers（ユーザー）の事例講演を聞きたい",
        "Sansan、Bill One、Contract Oneに関する講演を聴きたい",
      ],
      characterGifPattern: "twoHands",
      characterCommentImagePattern: "mokumoku",
      children: [
        {
          characterComment: "あなたのお役回りに\n最も近いのはどれですか？",
          choices: [
            "営業・マーケティング",
            "営業企画・経営企画",
            "経理・財務",
            "法務・総務",
          ],
          characterGifPattern: "natural",
          characterCommentImagePattern: "mokumoku",
          children: [
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・15:20~ toBeマーケティング株式会社（会場：3階 3-D）\n「デジタル名刺が変えたインバウンドマーケティング戦略」",
                "・16:40~ 本田技研工業株式会社（会場：3階 3-B）\n「Hondaにおける全社DXと改革推進リーダーの心構え」",
                "・18:00~ 株式会社エレクトリ（会場：3階 3-B）\n「売上130％増に寄与した、現場が主導する営業改革 」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・15:20~ 森トラスト株式会社（会場：3階 3-B）\n「顧客データの信頼性を高め、活用できる顧客基盤を構築」",
                "・16:40~ 株式会社アグレックス（会場：3階 3-D）\n「Sansan×CRM連携で実現した営業・マーケ改革」",
                "・18:00~ 日本通運株式会社（会場：3階 3-D）\n「日本通運が挑んだ営業DXの成果証明 」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・14:50~ 株式会社ボディワークホールディングス（会場：1階 1-A）\n「請求書発行から入金消込まで、早く正しく」",
                "・15:40~ 株式会社同仁社（会場：1階 1-A）\n「『紙ゼロ・残業ゼロ』の経理へ」",
                "・15:40~ UNISOLビジネスパートナーズ株式会社（会場：1階 1-B）\n「シェアード化で実現する月1,960時間の業務削減」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・16:40~ 双日テックイノベーション株式会社（会場：1階 1-B）\n「600時間の削減を実現する、AI時代の契約管理」",
                "・18:00~ 日建レンタコム株式会社（会場：1階 1-B）\n「未整備の契約管理に挑んだ、全社統一への『初陣』」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
          ],
        },
        {
          characterComment: "質問・相談をしたい\nサービスはどれですか？",
          choices: [
            "名刺管理から、収益を最大化する 「Sansan」",
            "経理DXから、全社の働き方を変える「Bill One」",
            "AI契約データベースが、利益を守る「Contract One」",
          ],
          characterGifPattern: "natural",
          characterCommentImagePattern: "guruguru",
          children: [
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・16:00~ Product Session（会場：3階 3-C）\n「Sansan×AIの未来」",
                "・16:40~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「組織営業力を向上する Sansan AIエージェント」",
                "・17:20~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「社員が渡す名刺の価値を最大化する デジタル名刺ソリューション」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・14:40~ Product Session（会場：3階 3-C）\n「『なくせる』をつくり、全社の働き方を変える」",
                "・15:20~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「立替経費はなくせる！？驚きの経費精算体験を実演」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment:
                "あなたには、\nこちらのセッションが\nおすすめです。",
              choices: [
                "・14:00~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「自社の利益を守る AI契約データベースの活用術」",
                "・17:20~ Product Session（会場：3階 3-C）\n「AI×契約情報がリスクと好機を捉え、営業戦略を変える」",
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
          ],
        },
      ],
    },
    {
      characterComment: "どのサービスの講演を\n聞きたいですか？",
      choices: [
        "名刺管理から、収益を最大化する 「Sansan」",
        "経理DXから、全社の働き方を変える「Bill One」",
        "AI契約データベースが、利益を守る「Contract One」",
      ],
      characterGifPattern: "twoHands",
      characterCommentImagePattern: "mokumoku",
      children: [
        {
          characterComment: "Sansanブースで\n担当者が\nお話を伺います",
          choices: [
            `3-A コミュニティーエリアにあるSansanブースにて、担当者と直接お話しいただけます。お気軽にお立ち寄りください。

また、ミニステージでは、Sansanの機能についてご紹介するセッションもご用意しています。`,
            "・16:40~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「組織営業力を向上する Sansan AIエージェント」",
            "・17:20~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「社員が渡す名刺の価値を最大化する デジタル名刺ソリューション」",
            "・18:00~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「新プロダクト！取引先データで変わる企業の動き方」",
          ],
          characterGifPattern: "point",
          characterCommentImagePattern: "maru",
          isFinalAnswer: true,
        },
        {
          characterComment: "Bill Oneブースで\n担当者が\nお話を伺います",
          choices: [
            `3-A コミュニティーエリアにあるBill Oneブースにて、担当者と直接お話しいただけます。お気軽にお立ち寄りください。

また、ミニステージでは、Bill Oneの機能についてご紹介するセッションもご用意しています。`,
            "・15:20~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「立替経費はなくせる！？驚きの経費精算体験を実演」",
          ],
          characterGifPattern: "point",
          characterCommentImagePattern: "maru",
          isFinalAnswer: true,
        },
        {
          characterComment: "Contract One\nブースで担当者が\nお話を伺います",
          choices: [
            `3-A コミュニティーエリアにあるContract Oneブースにて、担当者と直接お話しいただけます。お気軽にお立ち寄りください。

また、ミニステージでは、Contract Oneの機能についてご紹介するセッションもご用意しています。`,
            "・14:00~ ミニステージ（会場：3階 3-A コミュニティーエリア内ミニステージ）\n「自社の利益を守る AI契約データベースの活用術」",
          ],
          characterGifPattern: "point",
          characterCommentImagePattern: "maru",
          isFinalAnswer: true,
        },
      ],
    },
    {
      characterComment: "あなたが気になる\nサービスはどれですか？",
      choices: [
        "名刺管理から、収益を最大化する 「Sansan」",
        "経理DXから、全社の働き方を変える「Bill One」",
        "AI契約データベースが、利益を守る「Contract One」",
      ],
      characterGifPattern: "twoHands",
      characterCommentImagePattern: "mokumoku",
      children: [
        {
          characterComment: "どなたのイチ押し機能が\n知りたいですか？",
          choices: [
            "toBeマーケティング株式会社",
            "日本通運株式会社",
            "本田技研工業株式会社",
            "三菱ＨＣキャピタル株式会社",
          ],
          characterGifPattern: "natural",
          characterCommentImagePattern: "mokumoku",
          children: [
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `toBeマーケティング株式会社のイチ押し機能は、「デジタル名刺ソリューション」です。

「toBeマーケティング株式会社では、『デジタル名刺ソリューション』を活用しています。展示会などで名刺交換した後、名刺情報をお客様のメールボックスへ届け、見込み顧客から忘れられない仕組みを構築しています」（ご担当者様より）

「デジタル名刺ソリューション」について、コミュニティーエリアのSansanブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `日本通運株式会社のイチ押し機能は、「コンタクト」です。

  「日本通運株式会社では、コンタクト機能を中心として、営業情報の共有・可視化に取り組んでいます。Sansanに記録した情報を基に、組織を横断した連携が生まれるなど、社内調整やリソース確保のプロセスを大幅に短縮できるようになりました」（ご担当者様より）

  「コンタクト」について、コミュニティーエリアのSansanブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `本田技研工業株式会社のイチ押し機能は、「名刺管理」です。

「本田技研工業株式会社では、DXの一環としてSansanの名刺管理を活用しています。営業現場だけでなく、マネジャーや役員、技術や調達部門の担当者で活用し、人脈を共有することで、業務効率の改善につなげています」（ご担当者様より）

Sansanを使った「名刺管理」について、コミュニティーエリアのSansanブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `三菱ＨＣキャピタル株式会社のイチ押し機能は、「Sansan Data Hub」です。

「三菱ＨＣキャピタル株式会社では、『Sansan Data Hub』を活用しています。『企業の名寄せ』『名刺から人物データを自動作成』『顧客データへのリッチ情報付与』を通じて、CRMを『使えるデータがある』環境に引き上げました」（ご担当者様より）

「Sansan Data Hub」について、コミュニティーエリアのSansanブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
          ],
        },
        {
          characterComment: "どなたのイチ押し機能が\n知りたいですか？",
          choices: [
            "株式会社同仁社",
            "株式会社ハトヤ観光",
            "株式会社ボディワークホールディングス",
          ],
          characterGifPattern: "natural",
          characterCommentImagePattern: "mokumoku",
          children: [
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `株式会社同仁社のイチ押し機能は、「請求書のオンライン受領」です。

「株式会社同仁社では、Bill Oneを導入して、オンラインで請求書を受領しています。月1000件以上発生していた紙の請求書の処理をデジタル化したことで、二重作業などの非効率な業務をなくし、紙ゼロ・残業ゼロを実現しました」（ご担当者様より）

「請求書のオンライン受領」について、コミュニティーエリアのBill Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `株式会社ハトヤ観光のイチ押し機能は、「立て替えがいらない経費精算」です。

「株式会社ハトヤ観光では、従来、小口現金・立替経費で行っていた煩雑な経費精算の業務を、Bill Oneビジネスカードに一元化。精算手続きが、証憑を撮影し提出するだけで完了するため、非効率な業務がなくなり、拠点当たり月7時間を削減することに成功しました」（ご担当者様より）

「立て替えがいらない経費精算」について、コミュニティーエリアのBill Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `株式会社ボディワークホールディングスのイチ押し機能は、「請求書発行の電子化」と「入金消込の自動化」です。

「株式会社ボディワークホールディングスでは、請求書発行から入金消込までをBill One上でワンストップで対応しています。請求書発行の電子化とリアルタイムでの自動入金消込により、債権管理の業務が早く正しくなりました」（ご担当者様より）

「請求書発行の電子化」と「入金消込の自動化」について、コミュニティーエリアのBill Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
          ],
        },
        {
          characterComment: "どなたのイチ押し機能が\n知りたいですか？",
          choices: [
            "株式会社オリエントコーポレーション",
            "双日テックイノベーション株式会社",
            "日建レンタコム株式会社",
          ],
          characterGifPattern: "natural",
          characterCommentImagePattern: "mokumoku",
          children: [
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `株式会社オリエントコーポレーションのイチ押し機能は、「契約書の柔軟な検索」です。

「株式会社オリエントコーポレーションでは、契約書の『全文検索機能』や、独自の管理項目が設定できる『拡張項目』によって、契約書の検索や管理の工数を大幅に削減しました」（ご担当者様より）

「契約書の柔軟な検索」について、コミュニティーエリアのContract Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `双日テックイノベーション株式会社のイチ押し機能は、「Contract One AI」です。

「双日テックイノベーション株式会社では、『Contract One AI』で業務を効率化しています。Contract Oneでデータ化した契約書の内容について、『中途解約の予告期日はいつか？』といった質問をAIにするだけで答えてくれます」（ご担当者様より）

「Contract One AI」について、コミュニティーエリアのContract Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
            {
              characterComment: "イチ押し機能を\nご紹介します",
              choices: [
                `日建レンタコム株式会社のイチ押し機能は、「契約書の正確なデータ化」です。

「日建レンタコム株式会社では、Contract Oneであらゆる契約書を一元管理しています。契約先名や契約締結日など、管理に重要な主要9項目は自動で正確にデータ化されるため、負担なく契約データベースの構築が実現できました」（ご担当者様より）

「契約書の正確なデータ化」について、コミュニティーエリアのContract Oneブースで詳しくご紹介していますので、ぜひお立ち寄りください。`,
              ],
              characterGifPattern: "point",
              characterCommentImagePattern: "maru",
              isFinalAnswer: true,
            },
          ],
        },
      ],
    },
    {
      characterComment: "スタンプを\n集められる場所を\nご案内します",
      choices: [
        `Keynote、Voyagers Session、Product Session、ミニステージなどのセッションに参加したり、コミュニティーエリアの展示ブースを回ったりすることで、スタンプを集めることができます。一部のスポットでは、クイズも出題されます。

集めたスタンプの数に応じて、抽選の回数が増えますので、ぜひ、さまざまなコンテンツにご参加ください。`,
      ],
      characterGifPattern: "point",
      characterCommentImagePattern: "maru",
      isFinalAnswer: true,
    },
  ],
};
